__turbopack_context__.v({
  "btn": "hsv9Vq_btn",
  "closeIcon": "hsv9Vq_closeIcon",
  "controls": "hsv9Vq_controls",
  "mobileCloseButton": "hsv9Vq_mobileCloseButton",
  "root": "hsv9Vq_root",
  "title": "hsv9Vq_title",
});
